<template>
  <div class="container-fluid">
    <div class="col-md-12 mb-2">
      <div class="card">
        <div class="card-header">
          <h5>Select an application from the list</h5>
        </div>
        <div class="card-body p-1 mb-3">
          <select
            class="form-control"
            v-model="selectedOption"
            @change="getPermissionsByApp"
          >
            <option v-for="item in appList" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="card">
        <div class="card-header" v-if="selectedOption !== ''">
          <h5>Permissions for {{ selectedOption }}</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="d-flex justify-content-end">
              <div class="form-group">
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="fas fa-search"></i>
                  </span>
                  <input
                    v-model="filter"
                    class="form-control"
                    placeholder="Search"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="container-fluid permissions-container">
              <div class="row">
                <div
                  class="col-md-6 col-lg-4 mb-3"
                  v-for="permission in permissions"
                  :key="permission.id"
                >
                  <div class="card">
                    <div class="card-body">
                      <div class="d-flex align-items-center">
                        <div class="d-flex align-items-center mt-1">
                          <p
                            v-if="permission.method === 'GET'"
                            class="badge bg-info"
                          >
                            {{ permission.method }}
                          </p>
                          <p
                            v-if="permission.method === 'POST'"
                            class="badge bg-success"
                          >
                            {{ permission.method }}
                          </p>
                          <p
                            v-if="permission.method === 'PUT'"
                            class="badge bg-warning"
                          >
                            {{ permission.method }}
                          </p>
                          <p
                            v-if="permission.method === 'DELETE'"
                            class="badge bg-danger"
                          >
                            {{ permission.method }}
                          </p>
                          <span class="ms-1"></span>
                          <p
                            class="text-xs text-bold text-primary"
                            style="
                              white-space: break-spaces;
                              overflow-wrap: break-word;
                              word-break: break-all;
                            "
                          >
                            {{ baseURL + permission.controller }}/{{
                              permission.endpoint
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="d-flex align-items-center">
                        <div class="text-center w-5">
                          <!-- Contenido opcional aquí -->
                        </div>
                        <div class="ms-3 flex-grow-1">
                          <div>
                            <p class="text-sm mb-1">{{ permission.name }}</p>
                            <p class="mb-0 text-xs">
                              {{ permission.description }}
                            </p>
                          </div>
                        </div>
                        <el-switch
                          v-model="permission.isActive"
                          @change="updateRolePermissionStatus(permission)"
                          size="large"
                          active-text="Yes"
                          inactive-text="No"
                          style="
                            --el-switch-on-color: #13ce66;
                            --el-switch-off-color: #ff4949;
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  ref,
  onBeforeMount,
  onMounted,
  computed,
  watch,
} from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import axios from "axios";
import {
  //showAddSuccessAlert,
  //showUpdateSuccessAlert,
  ///showConfirmAlert,
  showSuccessToast,
  showinfoToast,
  //showErrorToast,
} from "@/utils/alerts";

export default defineComponent({
  name: "assign-permissions",
  components: {},
  props: {},

  setup() {
    const baseURL =
      axios.defaults.baseURL
        .split("/")
        .filter((part) => part.toLowerCase() !== "security")
        .join("/") + "/";
    const filter = ref("");
    const store = useStore();
    const route = useRoute();
    const selectedOption = ref("");

    const permissions = ref([]);
    const permissionsBackup = ref([]);

    onBeforeMount(() => {});

    onMounted(async () => {
      await getApps();
    });

    const appList = computed(() => store.state.permissions.appList);
    const loading = computed(() => store.state.permissions.fetching);

    //Obtiene la informacion de un solo Rol (Id)
    const getRoleData = async () => {
      await store.dispatch("roles/getRole", route.params.roleId);
    };

    //Obtiene el listado de aplicaciones registradas en los permisos
    const getApps = async () => {
      await store.dispatch("permissions/getApps");
    };

    //Al seleccionar una aplicacion se actualiza el listado de permisos a desplegarse
    const getPermissionsByApp = async (event) => {
      await getPermissions(event.target.value);
    };

    const getPermissions = async (filter) => {
      let params = `?pageSize=250`;
      params += `&pageNumber=1`;
      params += `&filter=x.aplicacionName.contains("${filter}")`;
      await store.dispatch("roles/getPermissions", params);

      permissionsBackup.value = permissions.value =
        store.getters["roles/permissionsByRole"];
    };

    const updateRolePermissionStatus = async (permission) => {
      const rolePermissions = {
        roleId: route.params.roleId,
        permissionsId: [permission.id],
      };

      if (permission.isActive) {
        await store.dispatch("roles/AddPermissionsToRole", rolePermissions);
        showSuccessToast("Role permission has been added");
      } else {
        await store.dispatch("roles/RemovePermissionsToRole", rolePermissions);
        showinfoToast("Role permission has been removed");
      }
    };

    watch(permissions, async (newValue, oldValue) => {
      if (newValue != oldValue) {
        await getRoleData();
        let ids = store.getters["roles/getRolePermissions"]();
        for (const obj of permissions.value) {
          obj.isActive = ids.includes(obj.id);
        }
      }
    });

    watch(filter, () => {
      const filterValue = filter.value.toLowerCase();
      permissions.value =
        filter.value == ""
          ? permissionsBackup.value
          : permissions.value.filter((x) =>
              x.name.toLowerCase().includes(filterValue),
            );
    });

    return {
      baseURL,
      filter,
      permissions,
      selectedOption,
      appList,
      loading,
      getApps,
      getRoleData,
      getPermissions,
      getPermissionsByApp,
      updateRolePermissionStatus,
    };
  },
});
</script>

<style scoped>
.permissions-container {
  max-height: 550px;
  overflow-y: auto;
  scrollbar-width: thin;
}
.permissions-container::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
  border-radius: 10px;
}
.permissions-container::-webkit-scrollbar-thumb {
  background-color: #4cb1ff;
  border-radius: 10px;
}
</style>
